import { m } from '~/paraglide/messages'

export function PaidTrackBadge(props: {
  onClick: () => void
  isUnlocked: boolean
}) {
  return (
    <div
      className="relative h-[80px] w-[100px]"
      onClick={() => {
        if (props.isUnlocked) return
        props.onClick()
      }}
    >
      <svg
        width="100"
        height="79"
        viewBox="0 0 100 79"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <use
          href="#stroke0_24038_18885"
          fill="url(#paint0_linear_24038_18885)"
        />
        <use
          href="#stroke0_24038_18885"
          fill="url(#paint1_linear_24038_18885)"
        />
        <mask id="stroke1_24038_18885" fill="white">
          <use href="#stroke0_24038_18885" />
        </mask>
        <path
          d="M61.9355 74.97L80.1644 67.4781C87.3309 64.5328 90.9141 63.0601 93.5477 60.635C95.875 58.492 97.6607 55.8275 98.7581 52.8603C100 49.5025 100 45.6284 100 37.8803V32C100 20.7989 100 15.1984 97.8201 10.9202C95.9027 7.15695 92.8431 4.09734 89.0798 2.17987C84.8016 0 79.2011 0 68 0H32C20.7989 0 15.1984 0 10.9202 2.17987C7.15695 4.09734 4.09734 7.15695 2.17987 10.9202C0 15.1984 0 20.799 0 32V37.9795C0 45.6939 0 49.5512 1.233 52.8981C2.32264 55.8558 4.09594 58.5142 6.40829 60.6563C9.02489 63.0802 12.5863 64.5618 19.709 67.5249L37.4801 74.9177C41.989 76.7935 44.2435 77.7314 46.5772 78.1055C48.6462 78.4372 50.7545 78.4417 52.8249 78.1189C55.1601 77.7547 57.4186 76.8265 61.9355 74.97Z"
          strokeWidth="4"
          stroke="url(#paint2_linear_24038_18885)"
          mask="url(#stroke1_24038_18885)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_24038_18885"
            x1="28.1509"
            y1="-0.260259"
            x2="67.8546"
            y2="75.035"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3CE79F" />
            <stop offset="1" stopColor="#06E5F9" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_24038_18885"
            x1="24"
            y1="-8.80132e-07"
            x2="69.5"
            y2="71.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.09" stopColor="#CAFE65" />
            <stop offset="0.303858" stopColor="#ACF971" stopOpacity="0.79" />
            <stop offset="0.78" stopColor="#5CEC91" stopOpacity="0.23" />
            <stop offset="1" stopColor="#3CE79F" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_24038_18885"
            x1="50"
            y1="0"
            x2="50"
            y2="80"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0.5" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
          <path
            id="stroke0_24038_18885"
            d="M0 32C0 20.799 0 15.1984 2.17987 10.9202C4.09734 7.15695 7.15695 4.09734 10.9202 2.17987C15.1984 0 20.799 0 32 0H68C79.201 0 84.8016 0 89.0798 2.17987C92.843 4.09734 95.9027 7.15695 97.8201 10.9202C100 15.1984 100 20.7989 100 32V37.8803C100 45.6284 100 49.5025 98.7581 52.8603C97.6607 55.8275 95.875 58.492 93.5477 60.635C90.9141 63.0601 87.3309 64.5328 80.1644 67.4781L61.9355 74.97C57.4186 76.8265 55.1601 77.7547 52.8249 78.1189C50.7545 78.4417 48.6462 78.4372 46.5772 78.1055C44.2435 77.7314 41.989 76.7935 37.4801 74.9177L19.709 67.5249C12.5863 64.5618 9.02489 63.0802 6.40829 60.6563C4.09594 58.5142 2.32264 55.8559 1.233 52.8981C0 49.5512 0 45.6939 0 37.9795V32Z"
          />
        </defs>
      </svg>

      <span className="absolute left-0 right-0 top-[26px] mx-auto w-[90px] text-center text-sm font-bold text-[#054442]">
        {m.plus_reward_text()}
      </span>
    </div>
  )
}
